module.exports = __webpack_public_path__ + "img/workbench_icon10.25617d30.svg";